import React, {useState, useEffect} from 'react'
import parse from 'html-react-parser';
import Image from '../Image'
import pack from './img/package_grutto_nl.jpg';
import pack_de from './img/freezer-fit_de.jpg';
import {isNil, toNumber} from "lodash";
import W from '../Word';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../../utils/functions';

const Freezer = ({config, weight}) => {
    const [item, setItem] = useState();
    const { t } = useTranslation();
    const data = t("freezer", {'returnObjects': true});
    let freezerImage = pack;
    if(currentLang() == 'de'){
        freezerImage = pack_de; 
    }
    const getNumberFromString = str =>{
        var regex = /[+-]?\d+(\.\d+)?(\,\d+)?/g;
        var floats = str.match(regex).map(function(v) { return parseFloat(v.replace(',', '.')); });
        return toNumber(floats);
    }
    
    //console.log(getNumber("8,1 KG"), getNumber("7kg"), getNumber("4.8 KG"))
    useEffect(() => {
        if(weight !== undefined){
            //weight = toNumber(weight.replace(' KG', '').replace(',', '.'));
            weight = getNumberFromString(weight);
            
            if(weight <= toNumber(data.kg4.size)){
                setItem(data.kg4);
            }else{
                if(weight > toNumber(data.kg8.size)){
                    setItem(data.kg8);
                }else{
                    setItem(data.kg6);
                }
            }
        }
        if(config && config !== 'automatic'){
            if(config == 'large')
                setItem(data.kg8);
            else if(config == 'medium')
                setItem(data.kg6);
            else
                setItem(data.kg4);
        }
        
    }, [weight])
    
    
    return (
        <section className="freezer-fit bg--gray_light">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6">
                        <div className="freezer-fit__img">
                            <h4 className="heading--h4">{t('freezer_text')}</h4>
                            <Image src={freezerImage} />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="freezer-fit__content">
                            <div className="weight">{(weight) ? weight : (config) ? item && item.size+' KG' : ''}</div>
                            <h4 className="heading--h4">{item && item.title}</h4>
                            <div className="row">
                                <div className="col">
                                    <div className={"freezer-fit__item " + (item && item.active == 1 ? 'active' : '')}>
                                        <span className="icon-freezer-1"></span>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className={"freezer-fit__item " + (item && item.active == 2 ? 'active' : '')}>
                                        <span className="icon-freezer-2"></span>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className={"freezer-fit__item " + (item && item.active == 3 ? 'active' : '')}>
                                        <span className="icon-freezer-3"></span>
                                    </div>
                                </div>
                            </div>
                            <p className="freezer-fit__desc">
                                {item && parse(item.body)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Freezer
